/* Moon Peak - Loop motion layer. No dependencies.
   Short text scrambles, long copy rises word by word.
   Anything already on screen at load plays immediately; everything below
   the fold waits for the scroll.

   NOTE: deliberately regex-free where whitespace is concerned. Escape
   sequences do not survive the theme upload path reliably, so whitespace is
   detected by character code instead. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SHORT = 60;
  var BAIL_MS = 4000;

  function isWs(ch) {
    var c = ch.charCodeAt(0);
    return c === 32 || c === 9 || c === 10 || c === 13 || c === 11 || c === 12 || c === 160;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function startClock(el) {
    var target = Date.parse(el.dataset.target);
    if (isNaN(target)) { el.setAttribute('data-done', '1'); return; }

    var f = {
      d: el.querySelector('[data-u="d"]'),
      h: el.querySelector('[data-u="h"]'),
      m: el.querySelector('[data-u="m"]'),
      s: el.querySelector('[data-u="s"]')
    };
    var last = {};
    var timer;

    function put(node, key, val) {
      if (!node || last[key] === val) return;
      last[key] = val;
      node.textContent = val;
      if (REDUCED) return;
      node.classList.add('is-tick');
      setTimeout(function () { node.classList.remove('is-tick'); }, 180);
    }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        el.setAttribute('data-done', '1');
        ['d', 'h', 'm', 's'].forEach(function (k) { if (f[k]) f[k].textContent = '00'; });
        var done = el.getAttribute('data-done-text');
        if (done) {
          var note = el.parentNode.querySelector('[data-clock-note]');
          if (note) note.textContent = done;
        }
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      put(f.d, 'd', pad(Math.floor(s / 86400)));
      put(f.h, 'h', pad(Math.floor(s % 86400 / 3600)));
      put(f.m, 'm', pad(Math.floor(s % 3600 / 60)));
      put(f.s, 's', pad(s % 60));
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  var DUDS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/<>[]{}#*';

  function nameIt(el, text) {
    if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', text.trim());
  }

  function light(scope) {
    var host = (scope && scope.closest && scope.closest('section')) || document;
    host.querySelectorAll('.lp-hi').forEach(function (h, i) {
      setTimeout(function () { h.classList.add('is-lit'); }, 90 * i);
    });
  }

  function scramble(el) {
    var text = el.textContent;
    if (!text.trim()) { el.classList.add('scramble-settled'); return; }

    nameIt(el, text);
    if (REDUCED) { el.classList.add('scramble-settled'); return; }

    var chars = text.split('');
    var plan = chars.map(function (c, i) {
      if (isWs(c)) return null;
      var start = Math.floor(i * 1.6 + Math.random() * 10);
      return { start: start, end: start + 8 + Math.floor(Math.random() * 12), c: c };
    });
    var total = plan.reduce(function (m, p) { return p ? Math.max(m, p.end) : m; }, 0);

    el.textContent = '';
    var inner = document.createElement('span');
    inner.setAttribute('aria-hidden', 'true');
    el.appendChild(inner);

    var frame = 0;
    var done = false;
    el.classList.add('scramble-running');

    var bail = setTimeout(finish, BAIL_MS);

    function finish() {
      if (done) return;
      done = true;
      clearTimeout(bail);
      inner.textContent = text;
      el.classList.remove('scramble-running');
      el.classList.add('scramble-settled');
      light(el);
    }

    function step() {
      if (done) return;
      var out = '';
      var pending = false;
      for (var i = 0; i < chars.length; i++) {
        var p = plan[i];
        if (!p) { out += chars[i]; continue; }
        if (frame >= p.end) {
          out += p.c;
        } else if (frame >= p.start) {
          out += '<span class="scramble-dud">' + DUDS[Math.floor(Math.random() * DUDS.length)] + '</span>';
          pending = true;
        } else {
          out += '<span class="scramble-dud">&nbsp;</span>';
          pending = true;
        }
      }
      inner.innerHTML = out;
      frame++;
      if (frame <= total + 1 || pending) requestAnimationFrame(step);
      else finish();
    }
    requestAnimationFrame(step);
  }

  /* Manual tokeniser - splits on runs of whitespace without touching regex. */
  function splitWords(el) {
    var text = el.textContent;
    nameIt(el, text);

    var holder = document.createElement('span');
    holder.setAttribute('aria-hidden', 'true');

    var n = 0, word = '', gap = '';

    function flushWord() {
      if (!word) return;
      var w = document.createElement('span');
      w.className = 'lp-w';
      w.textContent = word;
      w.style.transitionDelay = Math.min(n * 26, 900) + 'ms';
      holder.appendChild(w);
      n++;
      word = '';
    }
    function flushGap() {
      if (!gap) return;
      holder.appendChild(document.createTextNode(gap));
      gap = '';
    }

    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if (isWs(ch)) { flushWord(); gap += ch; }
      else { flushGap(); word += ch; }
    }
    flushWord();
    flushGap();

    el.textContent = '';
    el.appendChild(holder);
  }

  var TEXT_SEL = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'p', 'li', 'summary', 'figcaption', 'blockquote',
    'th', 'td', 'dt', 'dd', 'button', 'a.btn', 'a.lp-btn',
    '.lp-mono', '.lp-num b', '.lp-stat b', '.lp-stat p',
    '.eye', '.label', '.lede', '.price', '.card-title'
  ].join(',');

  function claimable(el) {
    if (el.hasAttribute('data-scramble') || el.hasAttribute('data-anim')) return false;
    if (el.hasAttribute('aria-label')) return false;
    if (el.closest('.lp-marq')) return false;
    if (el.closest('#site-audio')) return false;
    if (el.closest('.lp-clock')) return false;
    if (el.closest('form')) return false;
    if (el.children.length) return false;
    return !!el.textContent.trim();
  }

  function claimAll() {
    var words = [];
    document.querySelectorAll(TEXT_SEL).forEach(function (el) {
      if (!claimable(el)) return;
      if (el.textContent.trim().length <= SHORT) {
        el.setAttribute('data-scramble', '');
      } else {
        el.setAttribute('data-anim', 'words');
        if (!REDUCED) splitWords(el);
        words.push(el);
      }
    });
    return words;
  }

  function mark(el) {
    if (el && !el.hasAttribute('data-scramble')) el.setAttribute('data-scramble', '');
  }

  function decorate() {
    document.querySelectorAll('.lp-hero h1, .lp-echo').forEach(function (el) {
      var echo = el.querySelector('i');
      if (!echo) { mark(el); return; }
      var lead = document.createElement('span');
      while (el.firstChild && el.firstChild !== echo) lead.appendChild(el.firstChild);
      if (lead.textContent.trim()) {
        lead.style.display = 'block';
        el.insertBefore(lead, echo);
        mark(lead);
      }
      mark(echo);
    });

    document.querySelectorAll('.lp-num b, .lp-mono').forEach(mark);

    document.querySelectorAll('.lp-stat, .lp-media, .lp-btn').forEach(function (el) {
      el.classList.add('lp-sweep');
    });

    var cta = document.querySelector('.lp-hero .lp-btn:not(.lp-btn-ghost)');
    if (cta) cta.classList.add('lp-breathe');

    document.querySelectorAll('.lp-num span').forEach(function (el) {
      el.classList.add('lp-current');
    });

    if (!REDUCED && !document.querySelector('.lp-grain')) {
      var g = document.createElement('div');
      g.className = 'lp-grain';
      g.setAttribute('aria-hidden', 'true');
      document.body.appendChild(g);
    }

    document.querySelectorAll('.lp-split').forEach(function (sp) {
      var kids = sp.children;
      if (kids[0]) kids[0].querySelectorAll('.lp-rv').forEach(function (n) { n.classList.add('from-left'); });
      if (kids[1]) kids[1].querySelectorAll('.lp-rv').forEach(function (n) { n.classList.add('from-right'); });
    });
  }

  function run() {
    decorate();
    var wordEls = claimAll();
    document.querySelectorAll('[data-clock]').forEach(startClock);

    document.querySelectorAll('.lp-marq-track').forEach(function (track) {
      var set = track.querySelector('.lp-marq-set');
      if (set && track.children.length === 1) track.appendChild(set.cloneNode(true));
    });

    var reveals = [].slice.call(document.querySelectorAll('.lp-rv'));
    var scrambles = [].slice.call(document.querySelectorAll('[data-scramble]'));
    var videos = document.querySelectorAll('video[preload="none"]');

    if (REDUCED || !('IntersectionObserver' in window)) {
      reveals.forEach(function (n) { n.classList.add('is-in'); });
      scrambles.forEach(function (n) { n.classList.add('scramble-settled'); });
      wordEls.forEach(function (n) { n.classList.add('words-in'); });
      document.querySelectorAll('.lp-hi').forEach(function (h) { h.classList.add('is-lit'); });
      return;
    }

    var fold = window.innerHeight;
    function onScreen(el) {
      var r = el.getBoundingClientRect();
      return r.top < fold && r.bottom > -40;
    }

    var nowReveals = reveals.filter(onScreen);
    var nowScrambles = scrambles.filter(onScreen);
    var nowWords = wordEls.filter(onScreen);

    nowReveals.forEach(function (n, i) {
      setTimeout(function () { n.classList.add('is-in'); }, 80 + Math.min(i, 8) * 90);
    });
    nowWords.forEach(function (n, i) {
      setTimeout(function () { n.classList.add('words-in'); }, 260 + Math.min(i, 8) * 90);
    });
    nowScrambles.forEach(function (n, i) {
      n.classList.add('scramble-ready');
      setTimeout(function () { scramble(n); }, 140 + Math.min(i, 10) * 70);
    });

    var restReveals = reveals.filter(function (n) { return !onScreen(n); });
    var restScrambles = scrambles.filter(function (n) { return !onScreen(n); });
    var restWords = wordEls.filter(function (n) { return !onScreen(n); });

    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var sec = e.target.closest('section') || e.target.parentNode;
        var peers = [].slice.call(sec.querySelectorAll('.lp-rv'));
        var i = Math.max(0, peers.indexOf(e.target));
        setTimeout(function () { e.target.classList.add('is-in'); }, Math.min(i, 6) * 90);
        ro.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    restReveals.forEach(function (n) { ro.observe(n); });

    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        scramble(e.target);
        so.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.25 });
    restScrambles.forEach(function (n) { n.classList.add('scramble-ready'); so.observe(n); });

    var wo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('words-in');
        wo.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    restWords.forEach(function (n) { wo.observe(n); });

    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.35 });
    videos.forEach(function (v) { v.muted = true; v.playsInline = true; vo.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();